import { render } from "./InitialLoadingScreen.vue?vue&type=template&id=7cb6fe27"
import script from "./InitialLoadingScreen.vue?vue&type=script&lang=js"
export * from "./InitialLoadingScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__